import { useTheme } from 'styled-components'

export const useAppTheme = useTheme
